import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.cropwise-accounts-login-layout', () => {
  import('./internal/cropwise_accounts_login_layout').then(({ default: init }) => init());
});
